
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1440 368","preserveAspectRatio":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#00ADA8","d":"M679.184 113.612C603.395 142.71 486 126.58 393.826 90.422 219.205 21.921 70.742 103.218 0 138.58v229h1440V.58c-24.5 5.5-79.7 21.72-134.04 52.65-68.75 39.135-195.17 117.973-353.205 60.382-129.753-47.285-197.781-29.099-273.571 0z"}})])
          )
        }
      }
    